import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StringHelper {
  constructor() {}

  // returns the formatted version or original
  formatPhoneNumber(phoneNumber: string): string {
    if (phoneNumber) {
      // Remove non-digits
      const cleaned = phoneNumber.replace(/\D/g, '');
      // Use Australian format <4 digits> <3 digits> <3 digits>
      const match = cleaned.match(/^(\d{4})(\d{3})(\d{3})$/);

      if (match) {
        return `${match[1]} ${match[2]} ${match[3]}`;
      } else {
        return phoneNumber;
      }
    }
    return '';
  }

  capitalizeFirstLetter(inp: string): string {
    return `${inp.charAt(0).toUpperCase()}${inp.slice(1).toLowerCase()}`;
  }
}
